import { create } from "zustand";
import { toast } from "sonner";

interface PopUpStore {
    isOpen: boolean;
    header: string;
    message: string;
    actionLabel?: string;
    actionCallback?: (param?: any) => void;
    actionParam?: any;
    openPopUp: (
        header: string,
        message: string,
        actionLabel?: string,
        actionCallback?: (param?: any) => void,
        actionParam?: any
    ) => void;
    closePopUp: () => void;
}

export const usePopUpStore = create<PopUpStore>((set) => ({
    isOpen: false,
    header: "",
    message: "",
    openPopUp: (header, message) => set({ isOpen: true, header, message }),
    closePopUp: () => set({ isOpen: false }),
}));

export const useErrorPopUp = create<PopUpStore>((set) => ({
    isOpen: false,
    header: "",
    message: "",
    openPopUp: (header, message) => {
        toast.error(header, { description: message }); // Show a toast notification
        set({ isOpen: true, header, message });
    },
    closePopUp: () => set({ isOpen: false }),
}));

export const useRequestPopUp = create<PopUpStore>((set) => ({
    isOpen: false,
    header: "",
    message: "",
    actionLabel: "",
    actionCallback: undefined,
    actionParam: undefined,
    openPopUp: (header, message, actionLabel, actionCallback, actionParam) =>
        set({ isOpen: true, header, message, actionLabel, actionCallback, actionParam }),
    closePopUp: () => set({ isOpen: false, actionLabel: undefined, actionCallback: undefined, actionParam: undefined }),
}))